export enum FormationLevelEnum {
  Medio = 2,
  Superior = 4,
  Especializacao = 6,
  Mestrado = 7,
  Doutorado = 8
}
